import { defineStore } from 'pinia';
import { User } from '@/types/api/users.types';
import { getCurrentUser } from '@/api/users.service';

export const useUserStore = defineStore('user', {
  state: () => ({
    currentUser: null as unknown as User,
  }),

  actions: {
    async getCurrentUser() {
      const response = await getCurrentUser();
      this.currentUser = response.data.data;
    },
  },
});
